import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlayerSideOutlined = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 48 48",
	style: { enableBackground: "new 0 0 48 48" },
	xmlSpace: "preserve",
	height: "2em",
	width: "2em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M27.5,23L19.2,8H11c-1.7,0-3,1.3-3,3v12c0,1.7,1.3,3,3,3h23v-3H27.5z M12.3,23c-1,0-1.3-0.3-1.3-1.4v-9.1 c0-1.1,0.4-1.5,1.5-1.5h5.3l6.6,12.1L12.3,23z" }),
		/* @__PURE__ */ _jsx("path", { d: "M34,28c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S37.3,28,34,28z M34,37c-1.6,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S35.6,37,34,37z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14,28c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S17.3,28,14,28z M14,37c-1.6,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S15.6,37,14,37z" })
	]
});
export default SvgSlayerSideOutlined;
